import type { SxProps, Theme } from "@mui/material/styles";

export const root =
  (size: number): SxProps<Theme> =>
  (theme) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: size,
    height: size,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.divider,
    flexShrink: 0,
    overflow: "hidden",
  });

export const image: SxProps<Theme> = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
  display: "block",
};
